const values = {
  1: "columns-1",
  2: "columns-2",
  3: "columns-3",
};

export default function getColumns(value) {
  return values[value];
}
